/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unneeded-ternary */

import { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import useStorage from 'hooks/useStorage'
import { Icon } from 'assets/index'
import { logoSmallBlack } from 'assets/Icons'
import { ResumeInputCard, ResMaskedInput, ErrorMsg } from './style'

interface ICardProps {
  isMask?: string
  children: string
  icon?: string
  small?: boolean
  green?: boolean
  secondary?: boolean
  disabled?: boolean
  onClick?: any
  placeholder: string
  handleChangeInput?: any
  names: string
  clickable?: boolean
  medium?: boolean
  semi?: boolean
  blocks?: any
  filter?: any
  onClickOK?: any
  loading?: any
  erro?: any
  onClickEdit?: any
  defaultValue?: any
  errorMsg?: string
  analyze?: boolean
  maxLength?: number
  id?: string
  maxWidth?: number
}

const TextDiv = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 12px;
`

export default function ResumeInputCardComponent(props: ICardProps) {
  const [disabled, setDisabled] = useState(true)
  const {
    placeholder,
    children,
    icon,
    handleChangeInput,
    isMask,
    names,
    clickable = true,
    blocks,
    onClickOK,
    loading,
    onClickEdit,
    errorMsg,
    maxLength,
    maxWidth,
  } = props
  const [text, setText] = useState(placeholder)
  const inputRef = useRef<HTMLInputElement>(null)
  const [user] = useStorage('User')

  useEffect(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus()
    }
  }, [disabled])

  return (
    <ResumeInputCard {...props}>
      {user?.permission !== 'READ' && clickable ? (
        loading ? (
          <img
            className="loading-img-button"
            src={logoSmallBlack}
            alt="card icon"
          />
        ) : disabled ? (
          <img
            className="editIcon"
            src={Icon('edit.svg')}
            alt="edit icon"
            onClick={() => {
              setDisabled((curr) => !curr)
              onClickEdit && onClickEdit()
            }}
          />
        ) : (
          <button
            type="button"
            className="editIcon edit-ok"
            onClick={() => {
              onClickOK && onClickOK()
              setDisabled((curr) => !curr)
            }}
          >
            OK
          </button>
        )
      ) : (
        <div />
      )}
      <TextDiv>
        {icon && (
          <img className="iconClickable" src={Icon(icon)} alt="card icon" />
        )}
        {isMask ? (
          disabled ? (
            <ResMaskedInput
              inputRef={inputRef}
              defaultValue={text}
              mask={isMask}
              maxLength={maxLength}
              blocks={blocks}
              placeholder={text}
              name={names}
              disabled
            />
          ) : (
            <ResMaskedInput
              mask={isMask}
              blocks={blocks}
              inputRef={inputRef}
              maxLength={maxLength}
              defaultValue={text}
              className={'on-edit-input'}
              onAccept={(e: any) => {
                setText(e)
                handleChangeInput(e)
              }}
              // placeholder={placeholder}
              name={names}
              disabled={disabled}
            />
          )
        ) : disabled ? (
          <>
            <input placeholder={text} disabled value={text} />
          </>
        ) : (
          <input
            ref={inputRef}
            // placeholder={placeholder}
            className="input-txt"
            value={text}
            maxLength={maxLength}
            onChange={(e) => {
              setText(e.target.value)
              handleChangeInput(e.target.value)
            }}
          />
        )}
      </TextDiv>
      <span className="hidden-span">{text ? text : 'la'}</span>
      <span className="title">{children}</span>
      {errorMsg && <ErrorMsg errorMsg={errorMsg}>{errorMsg}</ErrorMsg>}
    </ResumeInputCard>
  )
}
